import { AppMutation } from "./types";
import { MutationTree } from "vuex";
import { AppState } from "./index";

export const mutations: MutationTree<AppState> = {
  [AppMutation.CHANGE_NAV_EXPAND](state, isNavExpand: boolean) {
    state.isNavExpanded = isNavExpand;
  },
  [AppMutation.SET_LANGUAGE](state, language: string | undefined) {
    state.language = language || "en";
  },
};
